@if (isEdited || text?.trim()) {
  <p>
    @if (!isEdited) {
      <span class="note is-html-snippet" [innerHTML]="text"></span>
    }
    @if (isEdited) {
      <textarea (input)="resizeEditor()" maxlength="2000" class="note" #editor [(ngModel)]="editedText" (focusout)="onFinishEdit()" (keydown.enter)="onFinishEdit($event)"></textarea>
    }
  </p>
}
